import { AppColors } from "@/styles/colors";
import { GridItem, Text } from "@chakra-ui/react";

interface Props {
  outerPaddingX: string;
  innerPaddingX: string;
  paddingY: string;
  columnGap: string;
}

export const DocumentsHeader = ({
  outerPaddingX,
  innerPaddingX,
  paddingY,
  columnGap,
}: Props) => {
  return (
    <>
      <GridItem
        paddingLeft={outerPaddingX}
        paddingRight={columnGap}
        paddingY={paddingY}
        backgroundColor={AppColors.BACKGROUND_SECONDARY}
      >
        <Text
          fontWeight={700}
          fontSize={{ base: "11px", md: "12px", lg: "12px" }}
          color={AppColors.GRAY_TEXT}
        >
          NOMBRE DE ARCHIVO
        </Text>
      </GridItem>
      <GridItem
        paddingLeft={innerPaddingX}
        paddingRight={columnGap}
        paddingY={paddingY}
        backgroundColor={AppColors.BACKGROUND_SECONDARY}
      >
        <Text
          fontWeight={700}
          fontSize={{ base: "11px", md: "12px", lg: "12px" }}
          color={AppColors.GRAY_TEXT}
        >
          TIPO
        </Text>
      </GridItem>
      <GridItem
        paddingLeft={innerPaddingX}
        paddingRight={columnGap}
        paddingY={paddingY}
        backgroundColor={AppColors.BACKGROUND_SECONDARY}
      >
        <Text
          fontWeight={700}
          fontSize={{ base: "11px", md: "12px", lg: "12px" }}
          color={AppColors.GRAY_TEXT}
        >
          DESCARGAR
        </Text>
      </GridItem>
      <GridItem
        paddingLeft={innerPaddingX}
        paddingRight={outerPaddingX}
        paddingY={paddingY}
        backgroundColor={AppColors.BACKGROUND_SECONDARY}
        width="100%"
      >
        <Text
          fontWeight={700}
          fontSize={{ base: "11px", md: "12px", lg: "12px" }}
          color={AppColors.GRAY_TEXT}
          textAlign="center"
        >
          ACCIÓN
        </Text>
      </GridItem>
    </>
  );
};
